import { useForm } from "react-hook-form";
import { ICandidateFormInput, ICreateCandidateProps } from "./Candidate.model";
import { candidateService } from "../../service/Candidate/candidate.service";
import CandidateForm from "./_candidateForm";

const CandidateCreate = ({
  setCandidateDialog,
  loadCandidates,
}: ICreateCandidateProps) => {
  const methods = useForm<ICandidateFormInput>({
    defaultValues: {
      name: undefined,
      email: undefined,
      gender: undefined,
      hobby: undefined,
      address: undefined,
      phone: undefined,
      topics: undefined,
      year_of_experience: undefined,
    },
  });
  const { setError } = methods;

  const onSubmit = async (data: ICandidateFormInput) => {
    try {
      await candidateService.create(data);
      loadCandidates();
      setCandidateDialog(false);
    } catch (err: any) {
      if (err.response?.data) {
        const errors = err.response.data;

        Object.keys(errors).forEach((key) => {
          setError(key as any, {
            type: "server",
            message: errors[key][0], // first error message
          });
        });
      }
    }
  };

  return <CandidateForm methods={methods} onSubmit={onSubmit} isEdit={false} />;
};

export default CandidateCreate;
